import { useCallback, useEffect, useState } from "react";
import { adminApi, formatApiError } from "../lib/adminApi";

// Session lives in an httpOnly cookie set by the backend; the browser never sees the token.
// status: null = checking, false = signed out, string = signed-in admin email
export const useAdminAuth = () => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    adminApi
      .get("/admin/me")
      .then(({ data }) => setAdmin(data.email))
      .catch(() => setAdmin(false));
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await adminApi.post("/admin/login", { email, password });
      setAdmin(data.email);
      return "";
    } catch (err) {
      return formatApiError(err?.response?.data?.detail);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminApi.post("/admin/logout");
    } catch (err) {
      console.warn("Logout request failed; clearing local session anyway", err);
    }
    setAdmin(false);
  }, []);

  const expire = useCallback(() => setAdmin(false), []);

  return { admin, login, logout, expire };
};
